// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"356":"fa4686bc","621":"fa4686bc","839":"fa4686bc","861":"fa4686bc"}[chunkId] + ".chunk.css";
};